import axios from "axios";
import { getVisitorId } from "./visitor";

/**
 * Readable Backend API 用の axios インスタンス
 * baseURL と X-Readable-Visitor ヘッダーを自動付与する
 */
const api = axios.create({
  baseURL: process.env.REACT_APP_READABLE_BACKEND_URL,
});

// リクエストインターセプターで X-Readable-Visitor を必ず付与
api.interceptors.request.use(
  (config) => {
    const visitorId = getVisitorId();
    if (config.headers) {
      config.headers["X-Readable-Visitor"] = visitorId;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
